"use client";

import { useAuth } from "@/lib/auth-context";
import { Button } from "@/components/ui/button";
import { AlertCircle } from "lucide-react";
import { useRouter, usePathname } from "next/navigation";

export function TokenExpiryModal() {
  const { isTokenExpired } = useAuth();
  const router = useRouter();
  const pathname = usePathname();

  // Don't show modal on login page
  if (!isTokenExpired || pathname === "/login") {
    return null;
  }

  const handleLogin = () => {
    router.push("/login");
  };

  return (
    <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-[9999] backdrop-blur-sm">
      <div className="bg-background rounded-lg shadow-2xl max-w-md w-full mx-4 border-2 border-destructive">
        <div className="p-6">
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0">
              <div className="w-12 h-12 rounded-full bg-destructive/10 flex items-center justify-center">
                <AlertCircle className="h-6 w-6 text-destructive" />
              </div>
            </div>
            <div className="flex-1">
              <h2 className="text-xl font-bold mb-2">Session Expired</h2>
              <p className="text-muted-foreground mb-6">
                Your OIDC authentication token has expired. Please log in again to continue using the application.
              </p>
              <Button onClick={handleLogin} className="w-full" size="lg">
                Login Again
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
